// `id` of the global StickyBarTopSmall's RevStickyBar root. JP reuses it to query
// the bar element for tab-navigation visibility. StickyBarTopSmall.vue binds its
// root id to this constant, so it is the single source of truth.
export const STICKY_BAR_TOP_SMALL_ID = 'sticky-bar-top-small'
